// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  connectFunctionsEmulator,
  getFunctions,
  httpsCallable,
} from "firebase/functions";
import {
  initializeAuth,
  browserLocalPersistence,
  browserPopupRedirectResolver,
} from "firebase/auth";
import { getStorage } from "firebase/storage";
import {
  isLocalDevelopmentHost,
  resolveFirebaseAuthDomain,
} from "./firebaseAuthDomain";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const runtimeHostname =
  typeof window !== "undefined" ? window.location.hostname : "";
const isLocalDevHost = isLocalDevelopmentHost(runtimeHostname);
const effectiveAuthDomain = resolveFirebaseAuthDomain(
  runtimeHostname,
  process.env.REACT_APP_FIREBASE_AUTH_DOMAIN
);

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: effectiveAuthDomain,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const firebaseProjectId = firebaseConfig.projectId;
export const functionsRegion = "us-central1";

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const functions = getFunctions(app, functionsRegion);
export const storage = getStorage(app);
export const auth = initializeAuth(app, {
  persistence: browserLocalPersistence,
  popupRedirectResolver: browserPopupRedirectResolver,
});

// Localhost prefers emulators by default; set REACT_APP_USE_FIREBASE_EMULATORS=false
// to force production Firebase functions during local development.
const emulatorPreference = String(
  process.env.REACT_APP_USE_FIREBASE_EMULATORS || ""
).toLowerCase();
const shouldUseEmulators =
  isLocalDevHost &&
  emulatorPreference !== "false" &&
  emulatorPreference !== "0";
export const usingFunctionsEmulator = shouldUseEmulators;

const emulatorHost = "127.0.0.1";
const emulatorPort = 5001;
if (shouldUseEmulators) {
  console.log(
    `Connecting to Firebase Functions emulator at ${emulatorHost}:${emulatorPort}`
  );
  connectFunctionsEmulator(functions, emulatorHost, emulatorPort);
}

export { httpsCallable };
